import React from 'react';
import { connect } from 'react-redux';
import Confirm from 'react-confirm-bootstrap';
import { userActions } from '../_actions';
import { cocktailActions } from '../_actions';

class ConfirmClearData extends React.Component {

  onConfirm(user) {
    // Preform your action.

    /*
     const { dispatch } = this.props;
     dispatch(userActions.logout());
     this.props.clearDrinkList();
     */

    let userModifiedNew = {
      ...user,
      ['cabinet']: [],
      ['favorites']: [],
      ['keyIngredients']: []
    };

    const {dispatch} = this.props;
    dispatch(userActions.update(userModifiedNew, false));
    dispatch(cocktailActions.getMyRecipes(userModifiedNew.cabinet, userModifiedNew.keyIngredients));
  }

  render() {
    const {user} = this.props;
    return (
      <Confirm
        onConfirm={(e) => this.onConfirm(user)}
        body="Are you sure you want clear your bar inventory and favorite drinks?"
        confirmText="Yes, clear my selections"
        title="Clear My Selections">
        <button>Clear My Selections</button>
      </Confirm>
    )
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user, loggedIn } = authentication;
  return {
    user,
    loggedIn
  };
}

const connectedDeleteAccount = connect(mapStateToProps)(ConfirmClearData);
export { connectedDeleteAccount as ConfirmClearData };


// WEBPACK FOOTER //
// ./src/ConfirmClearData/ConfirmClearData.jsx